import src from "IMAGE";
export default { src, width: 552, height: 566, blurWidth: 0, blurHeight: 0};
